var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 10 12",
    width: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88.7915097 581.208318c.3988395.774472.1595358 1.006813-.5982593.580854l-8.7744689-5.188957c-.5583753-.348512-.5583753-.890642 0-1.20043l8.7744689-5.188957c.7577951-.425959 1.0369827-.193618.5982593.580854l-.2393037.425959c-1.4358222 2.633202-1.4358222 6.931516 0 9.603442z",
    fill: "#d2d2d2",
    transform: "matrix(-1 0 0 -1 89 582)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightInactive);
export default __webpack_public_path__ + "static/media/arrow_right_inactive.ef83661f2399afc4af4515821371dc25.svg";
export { ForwardRef as ReactComponent };